
const sampleOverview = [
    {
        'type': 'placeholder',
        'title': 'Add a chart to get started',
    },
    {
        'type': 'placeholder',
        'title': 'Add a chart to get started',
    },
    {
        'type': 'placeholder',
        'title': 'Add a chart to get started',
    },
    {
        'type': 'placeholder',
        'title': 'Add a chart to get started',
    },
]

const samplePosition = [
    {
        'type': 'placeholder',
        'title': 'Add a chart to get started',
    },
    {
        'type': 'placeholder',
        'title': 'Add a chart to get started',
    },
    {
        'type': 'placeholder',
        'title': 'Add a chart to get started',
    },
    {
        'type': 'placeholder',
        'title': 'Add a chart to get started',
    },
    {
        'type': 'placeholder',
        'title': 'Add a chart to get started',
    },
    {
        'type': 'placeholder',
        'title': 'Add a chart to get started',
    },

]

export {sampleOverview,samplePosition}